module.exports = __webpack_public_path__ + "static/media/team15.5b82be33.png";